import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      d="m11.013 3.767-2.066-1.6c-.267-.267-.867-.4-1.267-.4H5.147c-.8 0-1.667.6-1.867 1.4l-1.6 4.866c-.333.934.267 1.734 1.267 1.734h2.666c.4 0 .734.333.667.8L5.947 12.7c-.134.6.266 1.267.866 1.467.534.2 1.2-.067 1.467-.467l2.733-4.067"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.413 10.3c0 .933-.4 1.267-1.333 1.267h-.667c-.933 0-1.333-.334-1.333-1.267V3.767c0-.934.4-1.267 1.333-1.267h.667c.933 0 1.333.333 1.333 1.267V10.3Z"
    />
  </svg>
)
export default SvgComponent
